import React from 'react';
import './MultiplayerGames.css';

const MULTIPLAYER_GAMES = [
  {
    id: 'poker-battle',
    name: 'POKER WAR ARENA',
    description: 'Texas Hold\'em championship battle royale',
    icon: '🃏',
    type: 'contract',
    status: 'coming-soon',
    battleInfo: {
      warriors: '2-8 Fighters',
      entryTribute: '50 BLB',
      prizeSpoils: 'Winner takes 85%',
      difficultyLevel: 'MASTER',
      battleType: 'Strategy & Skill'
    }
  },
  {
    id: 'rummy-championship',
    name: 'RUMMY CONQUEST',
    description: 'Classic card melding tournament with strategic depth',
    icon: '🎯',
    type: 'contract',
    status: 'coming-soon',
    battleInfo: {
      warriors: '2-6 Players',
      entryTribute: '25 BLB',
      prizeSpoils: 'Pool Distribution',
      difficultyLevel: 'EXPERT',
      battleType: 'Memory & Logic'
    }
  },
  {
    id: 'horse-race-derby',
    name: 'THUNDER DERBY',
    description: 'Live horse racing with real-time betting action',
    icon: '🐎',
    type: 'contract',
    status: 'coming-soon',
    battleInfo: {
      warriors: 'Unlimited Bettors',
      minStake: '5 BLB',
      maxMultiplier: '50x Victory',
      difficultyLevel: 'FORTUNE',
      battleType: 'Prediction & Luck'
    }
  },
  {
    id: 'lottery-jackpot',
    name: 'MEGA JACKPOT VAULT',
    description: 'Progressive jackpot lottery with massive prize pools',
    icon: '💎',
    type: 'contract',
    status: 'coming-soon',
    battleInfo: {
      warriors: 'Global Players',
      ticketPrice: '10 BLB',
      jackpotSize: 'Progressive Pool',
      difficultyLevel: 'LEGENDARY',
      battleType: 'Pure Chance'
    }
  },
  {
    id: 'number-lottery',
    name: 'TRIPLE DIGIT DRAW',
    description: '3-number lottery with hourly draws and instant wins',
    icon: '🎱',
    type: 'contract',
    status: 'coming-soon',
    battleInfo: {
      warriors: 'All Players',
      ticketPrice: '2 BLB',
      maxPayout: '1000x Stake',
      difficultyLevel: 'MODERATE',
      battleType: 'Number Prediction'
    }
  },
  {
    id: 'image-lottery',
    name: 'SYMBOL TRINITY',
    description: '3-image matching lottery with themed symbol collections',
    icon: '🎰',
    type: 'contract',
    status: 'coming-soon',
    battleInfo: {
      warriors: 'Community Wide',
      ticketCost: '3 BLB',
      bonusRounds: 'Symbol Combos',
      difficultyLevel: 'CASUAL',
      battleType: 'Visual Matching'
    }
  },
  {
    id: 'lightning-bet',
    name: 'LIGHTNING STRIKES',
    description: 'Fast-paced betting with rapid fire prediction rounds',
    icon: '⚡',
    type: 'contract',
    status: 'coming-soon',
    battleInfo: {
      warriors: 'Speed Bettors',
      roundDuration: '30 Seconds',
      maxMultiplier: '25x Lightning',
      difficultyLevel: 'INTENSE',
      battleType: 'Speed & Reflexes'
    }
  },
  {
    id: 'treasure-hunt',
    name: 'DIGITAL TREASURE QUEST',
    description: 'Collaborative treasure hunting with hidden rewards',
    icon: '🗺️',
    type: 'contract',
    status: 'coming-soon',
    battleInfo: {
      warriors: '10-50 Hunters',
      entryFee: '15 BLB',
      treasureValue: 'Shared Discovery',
      difficultyLevel: 'ADVENTURE',
      battleType: 'Exploration & Clues'
    }
  },
  {
    id: 'crash-multiplayer',
    name: 'ROCKET WARFARE',
    description: 'Escape before the rocket explodes - ultimate timing battle',
    icon: '🚀',
    type: 'contract',
    status: 'coming-soon',
    battleInfo: {
      warriors: 'Unlimited Legion',
      minStake: '1 BLB',
      maxMultiplier: '100x Victory',
      difficultyLevel: 'ADRENALINE',
      battleType: 'Timing & Nerves'
    }
  },
  {
    id: 'battle-royale-cards',
    name: 'CARD BATTLE ROYALE',
    description: 'Last player standing in strategic card elimination rounds',
    icon: '⚔️',
    type: 'contract',
    status: 'coming-soon',
    battleInfo: {
      warriors: '20-100 Fighters',
      entryFee: '20 BLB',
      survivalBonus: 'Last 3 Standing',
      difficultyLevel: 'CHAMPION',
      battleType: 'Elimination Strategy'
    }
  }
];

const MultiplayerGames = ({ onNavigate }) => {
  return (
    <div className="multiplayer-games-grid">
      {MULTIPLAYER_GAMES.map((game) => (
        <div 
          key={game.id}
          className={`multiplayer-game-card ${game.status}`}
          onClick={() => game.status === 'active' && onNavigate(game.id)}
        >
          <div className="game-header">
            <div className="game-icon">{game.icon}</div>
            <div className="game-status-indicator">
              <div className={`status-dot ${game.status}`}></div>
              <span className="status-text">
                {game.status === 'active' ? 'ONLINE' : 'PREPARING'}
              </span>
            </div>
          </div>
          
          <div className="game-info">
            <h3 className="game-title">{game.name}</h3>
            <p className="game-description">{game.description}</p>
          </div>

          <div className="game-stats">
            {game.battleInfo.warriors && (
              <div className="stat-row">
                <span className="stat-label">WARRIORS</span>
                <span className="stat-value">{game.battleInfo.warriors}</span>
              </div>
            )}
            {game.battleInfo.entryTribute && (
              <div className="stat-row">
                <span className="stat-label">ENTRY FEE</span>
                <span className="stat-value">{game.battleInfo.entryTribute}</span>
              </div>
            )}
            {game.battleInfo.entryFee && (
              <div className="stat-row">
                <span className="stat-label">ENTRY FEE</span>
                <span className="stat-value">{game.battleInfo.entryFee}</span>
              </div>
            )}
            {game.battleInfo.ticketPrice && (
              <div className="stat-row">
                <span className="stat-label">TICKET PRICE</span>
                <span className="stat-value">{game.battleInfo.ticketPrice}</span>
              </div>
            )}
            {game.battleInfo.ticketCost && (
              <div className="stat-row">
                <span className="stat-label">TICKET COST</span>
                <span className="stat-value">{game.battleInfo.ticketCost}</span>
              </div>
            )}
            {game.battleInfo.prizeSpoils && (
              <div className="stat-row">
                <span className="stat-label">PRIZE POOL</span>
                <span className="stat-value">{game.battleInfo.prizeSpoils}</span>
              </div>
            )}
            {game.battleInfo.jackpotSize && (
              <div className="stat-row">
                <span className="stat-label">JACKPOT</span>
                <span className="stat-value">{game.battleInfo.jackpotSize}</span>
              </div>
            )}
            {game.battleInfo.treasureValue && (
              <div className="stat-row">
                <span className="stat-label">TREASURE</span>
                <span className="stat-value">{game.battleInfo.treasureValue}</span>
              </div>
            )}
            {game.battleInfo.survivalBonus && (
              <div className="stat-row">
                <span className="stat-label">BONUS</span>
                <span className="stat-value">{game.battleInfo.survivalBonus}</span>
              </div>
            )}
            {game.battleInfo.minStake && (
              <div className="stat-row">
                <span className="stat-label">MIN STAKE</span>
                <span className="stat-value">{game.battleInfo.minStake}</span>
              </div>
            )}
            {game.battleInfo.maxMultiplier && (
              <div className="stat-row">
                <span className="stat-label">MAX WIN</span>
                <span className="stat-value">{game.battleInfo.maxMultiplier}</span>
              </div>
            )}
            {game.battleInfo.maxPayout && (
              <div className="stat-row">
                <span className="stat-label">MAX PAYOUT</span>
                <span className="stat-value">{game.battleInfo.maxPayout}</span>
              </div>
            )}
            {game.battleInfo.roundDuration && (
              <div className="stat-row">
                <span className="stat-label">ROUND TIME</span>
                <span className="stat-value">{game.battleInfo.roundDuration}</span>
              </div>
            )}
            {game.battleInfo.bonusRounds && (
              <div className="stat-row">
                <span className="stat-label">BONUS</span>
                <span className="stat-value">{game.battleInfo.bonusRounds}</span>
              </div>
            )}
          </div>

          <div className="game-footer">
            <div className="difficulty-badge">
              <span className="difficulty-level">{game.battleInfo.difficultyLevel}</span>
              <span className="difficulty-type">{game.battleInfo.battleType}</span>
            </div>
            
            <button className={`engage-button ${game.status}`}>
              {game.status === 'active' ? 'JOIN BATTLE' : 'PREPARING'}
            </button>
          </div>

          <div className="reward-indicator">
            <span>💎 EARNS REWARDS</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MultiplayerGames;